import {Banner} from '@primer/react'
import {AriaAlert} from '@primer/react/experimental'
import {memo} from 'react'

import styles from './ErrorBanner.module.css'

type ErrorBannerProps = {
  /** The error message to display */
  children: React.ReactNode
}

/**
 * A pre-styled error banner for use inside the MarkdownEditor.
 * Wraps content in AriaAlert for accessibility announcements.
 *
 * @example
 * ```tsx
 * <MarkdownEditor
 *   banner={errorMessage ? <MarkdownEditor.ErrorBanner>{errorMessage}</MarkdownEditor.ErrorBanner> : undefined}
 * />
 * ```
 */
export const ErrorBanner = memo(({children}: ErrorBannerProps) => (
  <Banner
    hideTitle
    variant="critical"
    layout="compact"
    title="Error"
    description={<AriaAlert>{children}</AriaAlert>}
    flush
    className={styles.errorBanner}
  />
))
ErrorBanner.displayName = 'MarkdownEditor.ErrorBanner'
